import { combineReducers } from 'redux';
import coreUiReducer from './coreUi';

import blogPostsReducer from './blogPostsSlice';
import jobPostingsReducer from './jobPostingsSlice';
import imagesReducer from './imagesSlice';
import jobApplicationsReducer from './jobApplicationsSlice';
import messagesReducer from './messagesSlice';
import phasesReducer from './phasesSlice';
import ccEmailsReducer from './ccEmailsSlice';

const rootReducer = combineReducers({
  coreUi: coreUiReducer,
  blogPosts: blogPostsReducer,
  jobPostings: jobPostingsReducer,
  images: imagesReducer,
  jobApplications: jobApplicationsReducer,
  messages: messagesReducer,
  phases: phasesReducer,
  ccEmails: ccEmailsReducer,
});

export default rootReducer;
